import { BrandMark } from './BrandMark'

export function Nav() {
  return (
    <header className="site-nav">
      <BrandMark />
      <nav aria-label="Primary navigation">
        <a href="#work">WORK</a>
        <a href="#process">PROCESS</a>
        <a href="#pricing">PRICING</a>
      </nav>
      <a className="nav-cta" href="#contact">START A PROJECT <span aria-hidden="true">↗</span></a>
    </header>
  )
}
